/* eslint-disable consistent-return */
import { Flex, Pane, TableV2, Text } from '@leverege/ui-elements'
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import useDelayOverviewTable from '../hooks/useDelayOverviewTable'
import S from './DelayOverviewTable.css'
import NoDelayCodesPane from './NoDelayCodesPane'

function DelayOverviewTable( { fgJob, isFullScreen } ) {
  const { data1, data2, columns } = useDelayOverviewTable( fgJob, isFullScreen )
  const [ singleTable, setSingleTable ] = useState()

  const handleResize = ( e ) => {
    if ( e.target.innerWidth < 1760 ) return setSingleTable( true )
    setSingleTable( false )
  }

  useEffect( () => {
    window.addEventListener( 'resize', handleResize )
    return () => {
      window.removeEventListener( 'resize', handleResize )
    }
  } )

  return (
    <Pane
      variant='dashboardCardCustom'
      layout='flex:col'
      style={{ flex : 1, minWidth : 635, width : '100%' }}>
      <Pane variant='dashboardCardCustomBigHeader' style={{ paddingLeft : 16 }}>
        <Flex variant='rowSpaceBetween'>
          <Text variant='tableHeader'>Delay Overview</Text>
        </Flex>
      </Pane>
      <div
        style={{
          backgroundColor : '#E7EAEF',
          padding : 4,
          height : '100%',
        }}>
        <Flex
          gap={8}
          justify='space-between'
          wrap='wrap'
          style={{ height : '100%' }}>
          {singleTable ? (
            data1.length ? (
              <TableV2
                variant='delayTable'
                className={S.table}
                sortable={false}
                rowClassName={classNames( [ S.row, 'lev-sc-row' ] )}
                data={data1}
                columns={columns}/>
            ) : (
              <NoDelayCodesPane />
            )
          ) : (
            <>
              {data1.length ? (
                <TableV2
                  variant='delayTable'
                  className={S.table}
                  sortable={false}
                  rowClassName={classNames( [ S.row, 'lev-sc-row' ] )}
                  data={data1}
                  columns={columns}/>
              ) : (
                <NoDelayCodesPane />
              )}
              {data2.length ? (
                <TableV2
                  variant='delayTable'
                  className={S.table}
                  sortable={false}
                  rowClassName={classNames( [ S.row, 'lev-sc-row' ] )}
                  data={data2}
                  columns={columns}/>
              ) : (
                <NoDelayCodesPane />
              )}
            </>
          )}
        </Flex>
      </div>
    </Pane>
  )
}

export default DelayOverviewTable
